import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const KEY_PREFIX = "agent_access_";

export async function unlockAgent(token, agent, password) {
    const res = await axios.post(
        `${API}/auth/agent-access/unlock`,
        {
            agent,
            password,
        },
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }
    );

    

    

    sessionStorage.setItem(
        KEY_PREFIX + agent,
        res.data.access_token
    );

    
    

    return res.data.access_token;
}

export function getAgentToken(agent) {
    return sessionStorage.getItem(KEY_PREFIX + agent);
}

export function clearAgentToken(agent) {
    sessionStorage.removeItem(KEY_PREFIX + agent);
}